module.exports = __webpack_public_path__ + "static/media/menu.a90a2705.svg";